class AppDownloadStrip extends HTMLElement {
  connectedCallback() {
    this.strip = this.querySelector('.app-download-strip');
    if (!this.strip) return;

    this.lastScrollTop = 0;
    this.scrollThreshold = 6;
    this.minScrollToHide = 80;
    this.textTimer = null;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.strip.classList.remove('app-download-strip--initial');
        this.scheduleTextAnimation(480);
      });
    });

    this.onScroll = this.handleScroll.bind(this);
    window.addEventListener('scroll', this.onScroll, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    if (this.textTimer) window.clearTimeout(this.textTimer);
  }

  scheduleTextAnimation(delay = 0) {
    if (this.textTimer) window.clearTimeout(this.textTimer);

    this.textTimer = window.setTimeout(() => {
      this.strip.classList.remove('app-download-strip--text-ready');
      void this.strip.offsetWidth;
      this.strip.classList.add('app-download-strip--text-ready');
    }, delay);
  }

  handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const delta = scrollTop - this.lastScrollTop;

    if (Math.abs(delta) < this.scrollThreshold) return;

    if (delta > 0 && scrollTop > this.minScrollToHide) {
      if (!this.strip.classList.contains('app-download-strip--collapsed')) {
        this.strip.classList.add('app-download-strip--collapsed');
        this.strip.classList.remove('app-download-strip--text-ready');
      }
    } else if (delta < 0) {
      if (this.strip.classList.contains('app-download-strip--collapsed')) {
        this.strip.classList.remove('app-download-strip--collapsed');
        this.scheduleTextAnimation(320);
      }
    }

    if (scrollTop <= this.minScrollToHide) {
      this.strip.classList.remove('app-download-strip--collapsed');
      if (!this.strip.classList.contains('app-download-strip--text-ready')) {
        this.scheduleTextAnimation(320);
      }
    }

    this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  }
}

if (!customElements.get('app-download-strip')) {
  customElements.define('app-download-strip', AppDownloadStrip);
}
